// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"353":"4cae7430","455":"d78a6d26","585":"2e280f86","628":"72abe031","977":"5e473bda"}[chunkId] + ".chunk.js";
};